export const SCHEDULE_AVAILABILITY_OUTSIDE_HOURS = '#FAFBFC'
export const SCHEDULE_AVAILABILITY_OPEN_TIME_BORDER = 'rgba(0, 83, 255, 0.4)'
export const SCHEDULE_AVAILABILITY_OPEN_TIME_TEXT = '#4F5B62'
export const SCHEDULE_AVAILABILITY_BLOCKED_FILL = '#ECEFF1'
export const SCHEDULE_AVAILABILITY_BLOCKED_TEXT = '#4F5B62'
export const SCHEDULE_AVAILABILITY_BOOKED_LESSON = '#E0EAFF'
export const SCHEDULE_AVAILABILITY_GROUP_EVENT = '#F1E9D8'

export const SCHEDULE_AVAILABILITY_BLOCKED_STRIPE =
  'repeating-linear-gradient(-45deg, rgba(176, 184, 193, 0.28) 0, rgba(176, 184, 193, 0.28) 1px, transparent 1px, transparent 8px)'
